/** Exports the private function during testing. */
export const $private = (module, fn) => {
    if (process.env.NODE_ENV === 'test') {
        const name = fn.name;
        module.exports[name] = fn;
    }
    return fn;
};
